import FileService from "./file.service.js";
import FamilyEmblemService from "./familyEmblem.service.js";

const classes = {
  file: FileService,
  familyEmblem: FamilyEmblemService,
};

export default class {
  static create (name) {
    return new classes[name]();
  }
}
